module.exports = __webpack_public_path__ + "fontawesome-webfont.eot?674f50d287a8c48dc19ba404d20fe713";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/fontawesome-webfont.eot?v=4.7.0
// module id = 718
// module chunks = 27